import angular from 'angular';
import 'angular-sanitize';
import 'ui-select';

// ES modules are strict by default
const shopDirective = angular.module('applicationModule.shopsDirectives', ['ngSanitize', 'ui.select']);

shopDirective.directive('fileModel', [
    '$parse',
    function ($parse) {
        'use strict';
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                const model = $parse(attrs.fileModel);
                const modelSetter = model.assign;
                element.bind('change', function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }
]);

export default shopDirective;
